import { FunctionComponent, memo, Suspense, SVGProps, useMemo } from 'react'
import dynamic from 'next/dynamic'

const IconAdd = dynamic(() => import('@/icons/list/add').then((c) => c.IconAdd))
const IconAddSymbol = dynamic(() =>
  import('@/icons/list/addSymbol').then((c) => c.IconAddSymbol)
)
const IconAdvantageFileCheck = dynamic(() =>
  import('@/icons/list/advantageFileCheck').then(
    (c) => c.IconAdvantageFileCheck
  )
)
const IconAdvantageShieldCheck = dynamic(() =>
  import('@/icons/list/advantageShieldCheck').then(
    (c) => c.IconAdvantageShieldCheck
  )
)
const IconAdvantageUser = dynamic(() =>
  import('@/icons/list/advantageUser').then((c) => c.IconAdvantageUser)
)
const IconAlert = dynamic(() =>
  import('@/icons/list/alert').then((c) => c.IconAlert)
)
const IconAlertLarge = dynamic(() =>
  import('@/icons/list/alertLarge').then((c) => c.IconAlertLarge)
)
const IconApplicationCreate = dynamic(() =>
  import('@/icons/list/applicationCreate').then((c) => c.IconApplicationCreate)
)
const IconApproved = dynamic(() =>
  import('@/icons/list/approved').then((c) => c.IconApproved)
)
const IconAppSearchSettings = dynamic(() =>
  import('@/icons/list/appSearchSettings').then((c) => c.IconAppSearchSettings)
)
const IconArrow = dynamic(() =>
  import('@/icons/list/arrow').then((c) => c.IconArrow)
)
const IconArrowDoubleLeft = dynamic(() =>
  import('./list/arrowDoubleLeft').then((c) => c.IconArrowDoubleLeft)
)
const IconArrowDoubleRight = dynamic(() =>
  import('./list/arrowDoubleRight').then((c) => c.IconArrowDoubleRight)
)
const IconArrowDown = dynamic(() =>
  import('@/icons/list/arrowDown').then((c) => c.IconArrowDown)
)
const IconArrowDownSmall = dynamic(() =>
  import('@/icons/list/arrowDownSmall').then((c) => c.IconArrowDownSmall)
)
const IconArrowLeft = dynamic(() =>
  import('@/icons/list/arrowLeft').then((c) => c.IconArrowLeft)
)
const IconArrowRight = dynamic(() =>
  import('@/icons/list/arrowRight').then((c) => c.IconArrowRight)
)
const IconArrowUp = dynamic(() =>
  import('@/icons/list/arrowUp').then((c) => c.IconArrowUp)
)
const IconArrowUp2 = dynamic(() =>
  import('@/icons/list/arrowUp2').then((c) => c.IconArrowUp2)
)
const IconAttention = dynamic(() =>
  import('@/icons/list/attention').then((c) => c.IconAttention)
)
const IconBack = dynamic(() =>
  import('@/icons/list/back').then((c) => c.IconBack)
)
const IconBack2 = dynamic(() =>
  import('@/icons/list/back2').then((c) => c.IconBack2)
)
const IconBell = dynamic(() =>
  import('@/icons/list/bell').then((c) => c.IconBell)
)
const IconBoldSuccess = dynamic(() =>
  import('@/icons/list/boldSuccess').then((c) => c.IconBoldSuccess)
)
const IconBookOpen = dynamic(() =>
  import('@/icons/list/bookOpen').then((c) => c.IconBookOpen)
)
const IconBriefcase = dynamic(() =>
  import('@/icons/list/briefcase').then((c) => c.IconBriefcase)
)
const IconBurger = dynamic(() =>
  import('@/icons/list/burger').then((c) => c.IconBurger)
)
const IconCalculator = dynamic(() =>
  import('@/icons/list/calculator').then((c) => c.IconCalculator)
)
const IconCalendarDays = dynamic(() =>
  import('@/icons/list/calendarDays').then((c) => c.IconCalendarDays)
)
const IconCheck = dynamic(() =>
  import('@/icons/list/check').then((c) => c.IconCheck)
)
const IconCheckCircle2 = dynamic(() =>
  import('@/icons/list/checkCircle2').then((c) => c.IconCheckCircle2)
)
const IconCheckInCircle = dynamic(() =>
  import('@/icons/list/checkInCircle').then((c) => c.IconCheckInCircle)
)
const IconCheckMedium = dynamic(() =>
  import('@/icons/list/checkMedium').then((c) => c.IconCheckMedium)
)
const IconCheckSmall = dynamic(() =>
  import('@/icons/list/checkSmall').then((c) => c.IconCheckSmall)
)
const IconChevron = dynamic(() =>
  import('@/icons/list/chevron').then((c) => c.IconChevron)
)
const IconChevronDown = dynamic(() =>
  import('@/icons/list/chevronDown').then((c) => c.IconChevronDown)
)
const IconChevronLeft = dynamic(() =>
  import('@/icons/list/chevronLeft').then((c) => c.IconChevronLeft)
)
const IconClear = dynamic(() =>
  import('@/icons/list/clear').then((c) => c.IconClear)
)
const IconClipboardEdit = dynamic(() =>
  import('@/icons/list/clipboardEdit').then((c) => c.IconClipboardEdit)
)
const IconClock = dynamic(() =>
  import('@/icons/list/clock').then((c) => c.IconClock)
)
const IconClockChanges = dynamic(() =>
  import('@/icons/list/clockChanges').then((c) => c.IconClockChanges)
)
const IconClockExtend = dynamic(() =>
  import('@/icons/list/clockExtend').then((c) => c.IconClockExtend)
)
const IconClose = dynamic(() =>
  import('@/icons/list/close').then((c) => c.IconClose)
)
const IconCopy = dynamic(() =>
  import('@/icons/list/copy').then((c) => c.IconCopy)
)
const IconCorner = dynamic(() =>
  import('@/icons/list/corner').then((c) => c.IconCorner)
)
const IconDisposalOfTheRight = dynamic(() =>
  import('@/icons/list/disposalOfTheRight').then(
    (c) => c.IconDisposalOfTheRight
  )
)
const IconDownload = dynamic(() =>
  import('@/icons/list/download').then((c) => c.IconDownload)
)
const IconDuplicate = dynamic(() =>
  import('@/icons/list/duplicate').then((c) => c.IconDuplicate)
)
const IconEmptyList = dynamic(() =>
  import('@/icons/list/emptyList').then((c) => c.IconEmptyList)
)
const IconError = dynamic(() =>
  import('@/icons/list/error').then((c) => c.IconError)
)
const IconErrorCross = dynamic(() =>
  import('@/icons/list/errorCross').then((c) => c.IconErrorCross)
)
const IconErrorSend = dynamic(() =>
  import('@/icons/list/errorSend').then((c) => c.IconErrorSend)
)
const IconExcel = dynamic(() =>
  import('@/icons/list/excel').then((c) => c.IconExcel)
)
const IconExtensionOfRight = dynamic(() =>
  import('@/icons/list/extensionOfRight').then((c) => c.IconExtensionOfRight)
)
const IconEyeOff = dynamic(() =>
  import('@/icons/list/eyeOff').then((c) => c.IconEyeOff)
)
const IconEyeOn = dynamic(() =>
  import('@/icons/list/eyeOn').then((c) => c.IconEyeOn)
)
const IconFile = dynamic(() =>
  import('@/icons/list/file').then((c) => c.IconFile)
)
const IconFileDigit = dynamic(() =>
  import('@/icons/list/fileDigit').then((c) => c.IconFileDigit)
)
const IconFileSearch = dynamic(() =>
  import('@/icons/list/fileSearch').then((c) => c.IconFileSearch)
)
const IconFileSignature = dynamic(() =>
  import('@/icons/list/fileSignature').then((c) => c.IconFileSignature)
)
const IconFlagRu = dynamic(() =>
  import('@/icons/list/flagRu').then((c) => c.IconFlagRu)
)
const IconFolderTree = dynamic(() =>
  import('@/icons/list/folderTree').then((c) => c.IconFolderTree)
)
const IconForward = dynamic(() =>
  import('@/icons/list/forward').then((c) => c.IconForward)
)
const IconFrown = dynamic(() =>
  import('@/icons/list/frown').then((c) => c.IconFrown)
)
const IconGreenClose = dynamic(() =>
  import('@/icons/list/greenClose').then((c) => c.IconGreenClose)
)
const IconGridView = dynamic(() =>
  import('@/icons/list/gridView').then((c) => c.IconGridView)
)
const IconHome = dynamic(() =>
  import('@/icons/list/home').then((c) => c.IconHome)
)
const IconImage = dynamic(() =>
  import('@/icons/list/image').then((c) => c.IconImage)
)
const IconImport = dynamic(() =>
  import('@/icons/list/import').then((c) => c.IconImport)
)
const IconIncoming = dynamic(() =>
  import('@/icons/list/incoming').then((c) => c.IconIncoming)
)
const IconInfo = dynamic(() =>
  import('@/icons/list/info').then((c) => c.IconInfo)
)
const IconInvalid = dynamic(() =>
  import('@/icons/list/invalid').then((c) => c.IconInvalid)
)
const IconLink = dynamic(() =>
  import('@/icons/list/link').then((c) => c.IconLink)
)
const IconList = dynamic(() =>
  import('@/icons/list/list').then((c) => c.IconList)
)
const IconLoader = dynamic(() =>
  import('@/icons/list/loader').then((c) => c.IconLoader)
)
const IconLogo = dynamic(() =>
  import('@/icons/list/logo').then((c) => c.IconLogo)
)
const IconLogout = dynamic(() =>
  import('@/icons/list/logout').then((c) => c.IconLogout)
)
const IconMail = dynamic(() =>
  import('@/icons/list/mail').then((c) => c.IconMail)
)
const IconMailCheck = dynamic(() =>
  import('@/icons/list/mailCheck').then((c) => c.IconMailCheck)
)
const IconMax = dynamic(() => import('@/icons/list/max').then((c) => c.IconMax))
const IconMonitoring = dynamic(() =>
  import('@/icons/list/monitoring').then((c) => c.IconMonitoring)
)
const IconMoon = dynamic(() =>
  import('@/icons/list/moon').then((c) => c.IconMoon)
)
const IconMoreVertical = dynamic(() =>
  import('@/icons/list/moreVertical').then((c) => c.IconMoreVertical)
)
const IconNewSuccess = dynamic(() =>
  import('@/icons/list/newSuccess').then((c) => c.IconNewSuccess)
)
const IconNextArrow = dynamic(() =>
  import('@/icons/list/nextArrow').then((c) => c.IconNextArrow)
)
const IconOnlineSearchMenu = dynamic(() =>
  import('@/icons/list/onlineSearchMenu').then((c) => c.IconOnlineSearchMenu)
)
const IconOutgoing = dynamic(() =>
  import('@/icons/list/outgoing').then((c) => c.IconOutgoing)
)
const IconPdf = dynamic(() => import('@/icons/list/pdf').then((c) => c.IconPdf))
const IconPencil = dynamic(() =>
  import('@/icons/list/pencil').then((c) => c.IconPencil)
)
const IconPencilSmall = dynamic(() =>
  import('@/icons/list/pencilSmall').then((c) => c.IconPencilSmall)
)
const IconPhoneCall = dynamic(() =>
  import('@/icons/list/phoneCall').then((c) => c.IconPhoneCall)
)
const IconPinMap = dynamic(() =>
  import('@/icons/list/pinMap').then((c) => c.IconPinMap)
)
const IconPlus = dynamic(() =>
  import('@/icons/list/plus').then((c) => c.IconPlus)
)
const IconPrevArrow = dynamic(() =>
  import('@/icons/list/prevArrow').then((c) => c.IconPrevArrow)
)
const IconPrinter = dynamic(() =>
  import('@/icons/list/printer').then((c) => c.IconPrinter)
)
const IconProcessing = dynamic(() =>
  import('@/icons/list/processing').then((c) => c.IconProcessing)
)
const IconQuestion = dynamic(() =>
  import('@/icons/list/question').then((c) => c.IconQuestion)
)
const IconRemove = dynamic(() =>
  import('@/icons/list/remove').then((c) => c.IconRemove)
)
const IconRibbon = dynamic(() =>
  import('@/icons/list/ribbon').then((c) => c.IconRibbon)
)
const IconRollup = dynamic(() =>
  import('@/icons/list/rollup').then((c) => c.IconRollup)
)
const IconSearch = dynamic(() =>
  import('@/icons/list/search').then((c) => c.IconSearch)
)
const IconSearchSimple = dynamic(() =>
  import('@/icons/list/searchSimple').then((c) => c.IconSearchSimple)
)
const IconSelectArrow = dynamic(() =>
  import('@/icons/list/selectArrow').then((c) => c.IconSelectArrow)
)
const IconSeparatorLogo = dynamic(() =>
  import('@/icons/list/separatorLogo').then((c) => c.IconSeparatorLogo)
)
const IconSettings = dynamic(() =>
  import('@/icons/list/settings').then((c) => c.IconSettings)
)
const IconStar = dynamic(() =>
  import('@/icons/list/star').then((c) => c.IconStar)
)
const IconStars = dynamic(() =>
  import('@/icons/list/stars').then((c) => c.IconStars)
)
const IconStatusExpired = dynamic(() =>
  import('@/icons/list/statusExpired').then((c) => c.IconStatusExpired)
)
const IconStatusExpires = dynamic(() =>
  import('@/icons/list/statusExpires').then((c) => c.IconStatusExpires)
)
const IconStatusValid = dynamic(() =>
  import('@/icons/list/statusValid').then((c) => c.IconStatusValid)
)
const IconSuccess = dynamic(() =>
  import('@/icons/list/success').then((c) => c.IconSuccess)
)
const IconSuccessSend = dynamic(() =>
  import('@/icons/list/successSend').then((c) => c.IconSuccessSend)
)
const IconSun = dynamic(() => import('@/icons/list/sun').then((c) => c.IconSun))
const TagBG = dynamic(() => import('@/icons/list/tagBG').then((c) => c.TagBG))
const IconTelegram = dynamic(() =>
  import('@/icons/list/telegram').then((c) => c.IconTelegram)
)
const IconToEndArrow = dynamic(() =>
  import('@/icons/list/toEndArrow').then((c) => c.IconToEndArrow)
)
const IconToStartArrow = dynamic(() =>
  import('@/icons/list/toStartArrow').then((c) => c.IconToStartArrow)
)
const IconTrash = dynamic(() =>
  import('@/icons/list/trash').then((c) => c.IconTrash)
)
const IconUpload = dynamic(() =>
  import('@/icons/list/upload').then((c) => c.IconUpload)
)
const IconUser = dynamic(() =>
  import('@/icons/list/user').then((c) => c.IconUser)
)
const IconUser2 = dynamic(() =>
  import('@/icons/list/user2').then((c) => c.IconUser2)
)
const IconUserCog = dynamic(() =>
  import('@/icons/list/userCog').then((c) => c.IconUserCog)
)
const IconValid = dynamic(() =>
  import('@/icons/list/valid').then((c) => c.IconValid)
)
const IconValid2 = dynamic(() =>
  import('@/icons/list/valid2').then((c) => c.IconValid2)
)
const IconWait = dynamic(() =>
  import('@/icons/list/wait').then((c) => c.IconWait)
)
const IconWarning = dynamic(() =>
  import('@/icons/list/warning').then((c) => c.IconWarning)
)
const IconWhatsapp = dynamic(() =>
  import('@/icons/list/whatsapp').then((c) => c.IconWhatsapp)
)
const IconWrench = dynamic(() =>
  import('@/icons/list/wrench').then((c) => c.IconWrench)
)
const IconX = dynamic(() => import('@/icons/list/x').then((c) => c.IconX))
const IconAlertCircle = dynamic(() =>
  import('./list/alertCircle').then((c) => c.IconAlertCircle)
)
const IconChevronRight = dynamic(() =>
  import('./list/chevronRight').then((c) => c.IconChevronRight)
)
const IconChevronUp = dynamic(() =>
  import('./list/chevronUp').then((c) => c.IconChevronUp)
)
const IconExport = dynamic(() =>
  import('./list/export').then((c) => c.IconExport)
)
const IconExternalLink = dynamic(() =>
  import('./list/externalLink').then((c) => c.IconExternalLink)
)
const IconFiles = dynamic(() => import('./list/files').then((c) => c.IconFiles))
const IconHelpCircle = dynamic(() =>
  import('./list/helpCircle').then((c) => c.IconHelpCircle)
)
const IconMenu = dynamic(() => import('./list/menu').then((c) => c.IconMenu))
const IconSettings2 = dynamic(() =>
  import('./list/settings2').then((c) => c.IconSettings2)
)
const IconSiteCheckCircle2 = dynamic(() =>
  import('@/icons/list/siteCheckCircle2').then((c) => c.IconSiteCheckCircle2)
)
const IconUnavailable = dynamic(() =>
  import('./list/unavailable').then((c) => c.IconUnavailable)
)

export const ICONS = {
  add: IconAdd,
  addSymbol: IconAddSymbol,
  advantageFileCheck: IconAdvantageFileCheck,
  advantageShieldCheck: IconAdvantageShieldCheck,
  advantageUser: IconAdvantageUser,
  alert: IconAlert,
  alertCircle: IconAlertCircle,
  alertLarge: IconAlertLarge,
  applicationCreate: IconApplicationCreate,
  approved: IconApproved,
  appSearchSettings: IconAppSearchSettings,
  arrow: IconArrow,
  arrowDoubleLeft: IconArrowDoubleLeft,
  arrowDoubleRight: IconArrowDoubleRight,
  arrowDown: IconArrowDown,
  arrowDownSmall: IconArrowDownSmall,
  arrowLeft: IconArrowLeft,
  arrowRight: IconArrowRight,
  arrowUp: IconArrowUp,
  arrowUp2: IconArrowUp2,
  attention: IconAttention,
  back: IconBack,
  back2: IconBack2,
  bell: IconBell,
  boldSuccess: IconBoldSuccess,
  bookOpen: IconBookOpen,
  briefcase: IconBriefcase,
  burger: IconBurger,
  calculator: IconCalculator,
  calendarDays: IconCalendarDays,
  check: IconCheck,
  checkCircle2: IconCheckCircle2,
  checkInCircle: IconCheckInCircle,
  checkMedium: IconCheckMedium,
  checkSmall: IconCheckSmall,
  chevronDown: IconChevronDown,
  chevron: IconChevron,
  chevronLeft: IconChevronLeft,
  chevronRight: IconChevronRight,
  chevronUp: IconChevronUp,
  clear: IconClear,
  clipboardEdit: IconClipboardEdit,
  clock: IconClock,
  clockChanges: IconClockChanges,
  clockExtend: IconClockExtend,
  close: IconClose,
  copy: IconCopy,
  corner: IconCorner,
  disposalOfTheRight: IconDisposalOfTheRight,
  download: IconDownload,
  duplicate: IconDuplicate,
  emptyList: IconEmptyList,
  error: IconError,
  errorCross: IconErrorCross,
  errorSend: IconErrorSend,
  excel: IconExcel,
  export: IconExport,
  extensionOfRight: IconExtensionOfRight,
  externalLink: IconExternalLink,
  eyeOff: IconEyeOff,
  eyeOn: IconEyeOn,
  file: IconFile,
  fileDigit: IconFileDigit,
  files: IconFiles,
  fileSearch: IconFileSearch,
  fileSignature: IconFileSignature,
  flagRu: IconFlagRu,
  folderTree: IconFolderTree,
  forward: IconForward,
  frown: IconFrown,
  greenClose: IconGreenClose,
  gridView: IconGridView,
  helpCircle: IconHelpCircle,
  home: IconHome,
  image: IconImage,
  import: IconImport,
  incoming: IconIncoming,
  info: IconInfo,
  invalid: IconInvalid,
  link: IconLink,
  list: IconList,
  loader: IconLoader,
  logo: IconLogo,
  logout: IconLogout,
  mail: IconMail,
  mailCheck: IconMailCheck,
  max: IconMax,
  menu: IconMenu,
  monitoring: IconMonitoring,
  moon: IconMoon,
  moreVertical: IconMoreVertical,
  newSuccess: IconNewSuccess,
  nextArrow: IconNextArrow,
  onlineSearchMenu: IconOnlineSearchMenu,
  outgoing: IconOutgoing,
  pdf: IconPdf,
  pencil: IconPencil,
  pencilSmall: IconPencilSmall,
  phoneCall: IconPhoneCall,
  pinMap: IconPinMap,
  plus: IconPlus,
  prevArrow: IconPrevArrow,
  printer: IconPrinter,
  processing: IconProcessing,
  question: IconQuestion,
  remove: IconRemove,
  ribbon: IconRibbon,
  rollup: IconRollup,
  search: IconSearch,
  searchSimple: IconSearchSimple,
  selectArrow: IconSelectArrow,
  separatorLogo: IconSeparatorLogo,
  settings: IconSettings,
  settings2: IconSettings2,
  siteCheckCircle2: IconSiteCheckCircle2,
  star: IconStar,
  stars: IconStars,
  statusExpired: IconStatusExpired,
  statusExpires: IconStatusExpires,
  statusValid: IconStatusValid,
  success: IconSuccess,
  successSend: IconSuccessSend,
  sun: IconSun,
  tagBG: TagBG,
  telegram: IconTelegram,
  toEndArrow: IconToEndArrow,
  toStartArrow: IconToStartArrow,
  trash: IconTrash,
  unavailable: IconUnavailable,
  upload: IconUpload,
  user: IconUser,
  user2: IconUser2,
  userCog: IconUserCog,
  valid: IconValid,
  valid2: IconValid2,
  wait: IconWait,
  warning: IconWarning,
  whatsapp: IconWhatsapp,
  wrench: IconWrench,
  x: IconX,
}

export type IconName = keyof typeof ICONS

interface IconProps {
  name: IconName
}
export const Icon: FunctionComponent<IconProps & SVGProps<SVGSVGElement>> =
  memo(({ name, ...props }) => {
    const CurrentIcon = useMemo(() => ICONS[name], [name])

    if (CurrentIcon == null) {
      throw new Error(`Icon with name: "${name}" not found`)
    }

    return (
      <Suspense>
        <CurrentIcon {...props} />
      </Suspense>
    )
  })
